import { apiErrorCodes } from 'consts/api/apiErrorCodes';
import { commonTexts, groupsTexts } from 'consts/text';
import { getErrorMessageAndCode } from 'utils/errorHandlers/getErrorMessageAndCode';

export const groupAddEditErrorParser = (error: unknown) => {
    const { code } = getErrorMessageAndCode(error);

    if (code === apiErrorCodes.GROUP_NAME_TAKEN) {
        return groupsTexts.groupNameTakenErrorMessage;
    }

    return commonTexts.errorMessages.unknown;
};
